var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUp2YouLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FFF6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2857 33.1428V40H9V33.1428C9 29.9869 11.5584 27.4286 14.7143 27.4286C16.1666 27.4286 17.4924 27.9703 18.5005 28.8629C19.3097 26.6903 21.4027 25.1428 23.8572 25.1428C25.3095 25.1428 26.6352 25.6847 27.6434 26.5771C28.4525 24.4046 30.5456 22.8572 33 22.8572C36.1558 22.8572 38.7141 25.4153 38.7143 28.571C39.6693 27.8537 40.8565 27.4286 42.1429 27.4286C45.2988 27.4286 47.8572 29.9869 47.8572 33.1428V40H45.5714V33.1428C45.5714 31.2493 44.0364 29.7143 42.1429 29.7143C40.2494 29.7143 38.7143 31.2493 38.7143 33.1427V37.7143H36.4286V28.5714C36.4286 26.6778 34.8936 25.1428 33 25.1428C31.1065 25.1428 29.5715 26.6778 29.5715 28.5713V35.4286H27.2857V30.8571C27.2857 28.9635 25.7507 27.4286 23.8572 27.4286C21.9636 27.4286 20.4286 28.9635 20.4286 30.8571V37.7143H18.1429V33.1427C18.1428 31.2493 16.6078 29.7143 14.7143 29.7143C12.8207 29.7143 11.2857 31.2493 11.2857 33.1428V33.1428ZM42.1429 20.5714C43.7198 20.5714 45 21.8517 45 23.4286C45 25.0055 43.7198 26.2857 42.1429 26.2857C40.566 26.2857 39.2857 25.0055 39.2857 23.4286C39.2857 21.8517 40.566 20.5714 42.1429 20.5714ZM14.7143 20.5714C16.2912 20.5714 17.5714 21.8517 17.5714 23.4286C17.5714 25.0055 16.2912 26.2857 14.7143 26.2857C13.1374 26.2857 11.8571 25.0055 11.8571 23.4286C11.8571 21.8517 13.1374 20.5714 14.7143 20.5714ZM23.8572 18.2857C25.434 18.2857 26.7143 19.5659 26.7143 21.1428C26.7143 22.7198 25.434 24 23.8572 24C22.2802 24 21 22.7198 21 21.1428C21 19.5659 22.2802 18.2857 23.8572 18.2857ZM33 16C34.5769 16 35.8571 17.2802 35.8571 18.8571C35.8571 20.434 34.5769 21.7143 33 21.7143C31.4231 21.7143 30.1429 20.434 30.1429 18.8571C30.1429 17.2802 31.4231 16 33 16V16Z",
    fill: "#112A44"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp2YouLogo);
export default __webpack_public_path__ + "static/media/up2you-logo.efe4d1138b1868baf58a5966d5e64af6.svg";
export { ForwardRef as ReactComponent };